<template>
  <div class="select">
    <div>
      <h2>
        请选择团队
        <router-link :to="{name:'register',query:{currentStep:2}}" class="organize">创建团队</router-link>
      </h2>
      <span></span>
    </div>

    <Divider />
    <div class="contain">
      <Card v-for="(item,index) in companies" :key="index" class="companies">
        <div class="son" @click="selectEnterprise(item)">{{item.enterpriseName}}</div>
      </Card>
      <div v-if="!hasEnterprise" class="model">
        <ul>
          <li>欢迎使用GoBills</li>
          <li>您还没有任何团队，请先创建团队</li>
        </ul>
      </div>
    </div>
    <div class="route">
      <a href>观看产品演示</a>
      <a href @click.prevent="QRcode = true">下载APP(Android)</a>
    </div>

    <Modal v-model="QRcode" title="扫码下载APP" :mask-closable="false" footer-hide>
      <img class="QRcode" src="@/assets/QRcode.png" alt />
    </Modal>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  created() {
    this.$api.getEnterpriseList().then(data => {
      this.companies = data;

      this.hasEnterprise = data.length > 0;
    });
  },

  data() {
    return {
      QRcode: false,
      companies: [],

      hasEnterprise: true
    };
  },

  methods: {
    async selectEnterprise(enterprise) {
      await this.$store.dispatch("users/switchEnterprise", enterprise.id);

      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.contain {
  height: 250px;
  overflow: auto;
  margin-bottom: 40px;
}
.companies {
  margin: 10px auto;
  width: 400px !important;
  font-weight: 600;
  cursor: pointer;
}
.select {
  padding: 20px 40px 0 35px;
}
.route :nth-child(2) {
  float: right;
}
.organize {
  margin-top: 10px;
  float: right;
  vertical-align: text-bottom;
  font-size: 14px;
  font-weight: 400;
}
.son {
  width: 100%;
}
.model {
  height: 200px;
  width: 490px;
  text-align: center;
}
.model ul {
  margin-top: 50px;
  line-height: 50px;
}
.model li:nth-child(1) {
  font-size: 26px;
  font-weight: bold;
  color: #464c5b;
}
.model li:nth-child(2) {
  font-size: 21px;
  font-weight: bold;
}
.QRcode {
  margin: 0 auto;
}
</style>
